<div [ngClass]="this['data'] != undefined && this['data'].formType != undefined && this['data'].formType == 'aside' ? '' : ''">
    <div [ngClass]="this['data'] != undefined && this['data'].formType != undefined && this['data'].formType == 'aside' ? '' : ''">
        <div class="row">
            <div class="col-lg-12 pt-2">
                <div class="form-group row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <dhs-form [config]="configForm" [fieldGroup]="fields" (saveFinished)="addRow($event)" [action]="action" [formtype]="'popup'" [customButton]='btn' (getData)="getDataFn($event)" [bookmarks]="fields.bookmark!=undefined?this.fields:''" [decorator]="decorator" [data]="objData"  
                            ></dhs-form>
                        <div class="col-md-3 col-lg-3 col-xl-3"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
